import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVagrantComponent } from './simple-icons-vagrant.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVagrantComponent ],
    exports:      [ SimpleIconsVagrantComponent ],
    bootstrap:    []
})
export class SimpleIconsVagrantModule {}
